// 日本語 → Heliumセレクト用 value のマッピング
const prefectureMap = {
  北海道: 'Hokkaidō',
  青森県: 'Aomori',
  岩手県: 'Iwate',
  宮城県: 'Miyagi',
  秋田県: 'Akita',
  山形県: 'Yamagata',
  福島県: 'Fukushima',
  茨城県: 'Ibaraki',
  栃木県: 'Tochigi',
  群馬県: 'Gunma',
  埼玉県: 'Saitama',
  千葉県: 'Chiba',
  東京都: 'Tōkyō',
  神奈川県: 'Kanagawa',
  新潟県: 'Niigata',
  富山県: 'Toyama',
  石川県: 'Ishikawa',
  福井県: 'Fukui',
  山梨県: 'Yamanashi',
  長野県: 'Nagano',
  岐阜県: 'Gifu',
  静岡県: 'Shizuoka',
  愛知県: 'Aichi',
  三重県: 'Mie',
  滋賀県: 'Shiga',
  京都府: 'Kyōto',
  大阪府: 'Ōsaka',
  兵庫県: 'Hyōgo',
  奈良県: 'Nara',
  和歌山県: 'Wakayama',
  鳥取県: 'Tottori',
  島根県: 'Shimane',
  岡山県: 'Okayama',
  広島県: 'Hiroshima',
  山口県: 'Yamaguchi',
  徳島県: 'Tokushima',
  香川県: 'Kagawa',
  愛媛県: 'Ehime',
  高知県: 'Kōchi',
  福岡県: 'Fukuoka',
  佐賀県: 'Saga',
  長崎県: 'Nagasaki',
  熊本県: 'Kumamoto',
  大分県: 'Ōita',
  宮崎県: 'Miyazaki',
  鹿児島県: 'Kagoshima',
  沖縄県: 'Okinawa',
};

document.addEventListener('cf:ready', function () {
  console.log('Heliumフォーム読み込み完了');

  // 日付フィールドのプレースホルダーを変更
  document.querySelectorAll('.cf-date-field--inline-inputs select').forEach(function (select) {
    const firstOption = select.querySelector('option[value=""]');
    if (firstOption) {
      if (
        firstOption.textContent === 'Year' ||
        firstOption.textContent === 'Month' ||
        firstOption.textContent === 'Day'
      ) {
        firstOption.textContent = '---';
      }
    }
  });

  // 生年月日フィールドの条件付き必須バリデーション（どれか選択したらすべて必須）
  initBirthdateValidation();

  $(document).on('blur', '.js-zip input', function () {
    let val = $(this).val();

    // 入力を半角化（数字・ハイフン）
    val = toHalfWidth(val);

    // 入力欄に半角へ置き換えた値を反映
    $(this).val(val);

    // 数字のみで判定用
    let zipcode = val.replace(/[^0-9]/g, '');

    if (zipcode.length === 7) {
      $.ajax({
        url: 'https://zipcloud.ibsnet.co.jp/api/search',
        dataType: 'jsonp',
        data: { zipcode: zipcode },
      })
        .done(function (res) {
          if (res.status === 200 && res.results) {
            let result = res.results[0];
            let prefectureJa = result.address1;
            let city = result.address2 + result.address3;

            let prefectureValue = prefectureMap[prefectureJa];

            if (prefectureValue) {
              // data-cf-column-key属性でセレクト要素を取得（フォールバックあり）
              const selectEl =
                document.querySelector('[data-cf-column-key="default_address.province"] select') ||
                $('.js-province select')[0];
              if (selectEl) {
                setNativeValue(selectEl, prefectureValue);
                console.log('都道府県設定:', prefectureValue);
              }
            }

            // data-cf-column-key属性で市区町村入力欄を取得（フォールバックあり）
            const cityInput =
              document.querySelector('[data-cf-column-key="default_address.city"] input') || $('.js-city input')[0];
            if (cityInput) {
              setNativeValue(cityInput, city);
              console.log('市区町村設定:', city);
            }

            console.log('住所自動補完', prefectureJa, city);
          } else {
            alert('住所が見つかりませんでした');
          }
        })
        .fail(function () {
          alert('郵便番号検索に失敗しました');
        });
    }
  });
});

// 生年月日の条件付きバリデーション（どれか1つでも選択したら年・月・日すべて必須）
function initBirthdateValidation() {
  document.querySelectorAll('.cf-date-field--inline-inputs').forEach(function (container) {
    const selects = container.querySelectorAll('select');
    if (selects.length < 3) return;

    const fieldWrapper = container.closest('.cf-field');
    if (!fieldWrapper) return;

    let errorEl = fieldWrapper.querySelector('.cf-birthdate-validation-error');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'cf-birthdate-validation-error';
      errorEl.style.cssText = 'color:#d72c0d;font-size:0.85em;margin-top:4px;display:none;';
      container.parentNode.insertBefore(errorEl, container.nextSibling);
    }

    const form = container.closest('form');
    const submitBtn = form?.querySelector('.cf-submit-form');

    function validateBirthdate() {
      const year = selects[0].value;
      const month = selects[1].value;
      const day = selects[2].value;
      const filledCount = [year, month, day].filter(Boolean).length;

      if (filledCount === 0) {
        fieldWrapper.setAttribute('data-cf-invalid', 'false');
        errorEl.style.display = 'none';
        errorEl.textContent = '';
        if (submitBtn) submitBtn.style.opacity = '1';
        return true;
      }
      if (filledCount === 3) {
        fieldWrapper.setAttribute('data-cf-invalid', 'false');
        errorEl.style.display = 'none';
        errorEl.textContent = '';
        if (submitBtn) submitBtn.style.opacity = '1';
        return true;
      }
      fieldWrapper.setAttribute('data-cf-invalid', 'true');
      errorEl.textContent = '年・月・日をすべて選択してください';
      errorEl.style.display = 'block';
      if (submitBtn) submitBtn.style.opacity = '0.2';
      return false;
    }

    selects.forEach(function (select) {
      select.addEventListener('change', validateBirthdate);
    });
    validateBirthdate();
  });

  // フォーム送信時にバリデーション実行
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (form.tagName !== 'FORM') return;
      if (!form.querySelector('.cf-date-field--inline-inputs')) return;

      let isValid = true;
      form.querySelectorAll('.cf-date-field--inline-inputs').forEach(function (container) {
        const selects = container.querySelectorAll('select');
        if (selects.length < 3) return;
        const year = selects[0].value;
        const month = selects[1].value;
        const day = selects[2].value;
        const filledCount = [year, month, day].filter(Boolean).length;

        if (filledCount > 0 && filledCount < 3) {
          isValid = false;
          const fieldWrapper = container.closest('.cf-field');
          if (fieldWrapper) fieldWrapper.setAttribute('data-cf-invalid', 'true');
          const errorEl = fieldWrapper?.querySelector('.cf-birthdate-validation-error');
          if (errorEl) {
            errorEl.textContent = '年・月・日をすべて選択してください';
            errorEl.style.display = 'block';
          }
        }
      });

      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        const submitBtn = form.querySelector('.cf-submit-form');
        if (submitBtn) submitBtn.style.opacity = '0.2';
      }
    },
    true,
  );
}

// 全角 → 半角変換関数
function toHalfWidth(str) {
  return str.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0)).replace(/[ー−―]/g, '-');
}

// React/Vue対応のネイティブ値設定関数
function setNativeValue(element, value) {
  // フォーカスイベント
  element.focus();
  element.dispatchEvent(new Event('focus', { bubbles: true }));
  element.dispatchEvent(new Event('focusin', { bubbles: true }));

  // Reactの内部プロパティセッターを使用して値を設定
  const prototype = element.tagName === 'SELECT' ? HTMLSelectElement.prototype : HTMLInputElement.prototype;
  const valueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;
  const prototypeValueSetter = Object.getOwnPropertyDescriptor(Element.prototype, 'value')?.set;

  if (valueSetter && valueSetter !== prototypeValueSetter) {
    valueSetter.call(element, value);
  } else if (prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else {
    element.value = value;
  }

  // React 16+用のInputEvent
  const inputEvent = new Event('input', { bubbles: true });
  // React内部の_valueTrackerをリセット
  const tracker = element._valueTracker;
  if (tracker) {
    tracker.setValue('');
  }
  element.dispatchEvent(inputEvent);

  // 追加のイベントをディスパッチ
  element.dispatchEvent(new Event('change', { bubbles: true }));
  $(element).trigger('change');

  // blurイベント
  element.dispatchEvent(new Event('blur', { bubbles: true }));
  element.dispatchEvent(new Event('focusout', { bubbles: true }));
}
